import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import VueMeta from "vue-meta";

import { library } from "@fortawesome/fontawesome-svg-core";

import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons";
import { faTwitterSquare } from "@fortawesome/free-brands-svg-icons";
import { faFlickr } from "@fortawesome/free-brands-svg-icons";
import { faYoutubeSquare } from "@fortawesome/free-brands-svg-icons";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import JQuery from "jquery";

import VueInstagram from "vue-instagram";

import lodash from "lodash";
import VueLodash from "vue-lodash";

import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";

import Moment from "moment";

import Carousel3d from "vue-carousel-3d";

// SOCKET.IO CLIENT V4
import { io } from "socket.io-client";

library.add(
  faFacebookSquare,
  faInstagramSquare,
  faTwitterSquare,
  faFlickr,
  faYoutubeSquare,
  faSearch,
  faUser,
  faPlayCircle,
  faChevronLeft,
  faChevronRight,
  faSortDown,
  faVolumeUp,
  faArrowDown,
  faArrowUp,
);

Vue.use(Carousel3d);

Vue.use(VueLodash, {
  name: "custom",
  lodash: lodash
});

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueInstagram);

// SOCKET CONNECTION
const socket = io("https://ocs-ffg.com", {
  path: "/tms/ffg/socket.io",
  transports: ["websocket", "polling"],
});

// OPTIONAL DEBUGGING
socket.on("connect", () => {
  console.log("Socket connected:", socket.id);
});

socket.on("disconnect", () => {
  console.log("Socket disconnected");
});

socket.on("connect_error", (err) => {
  console.error("Socket connection error:", err);
});

// GLOBAL SOCKET ACCESS
Vue.prototype.$socket = socket;

Vue.use(VueAnalytics, {
  id: "G-1GJSGCY48B",
  router
});

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-1GJSGCY48B"
    },
    includes: [
      {
        id: "G-1GJSGCY48B"
      }
    ]
  },
  router
);

new Vue({
  Moment,
  router,
  store,
  axios,
  JQuery,
  lodash,
  render: h => h(App)
}).$mount("#app");